(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kom-home-campaign"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('kom-campaign-video'))customElements.define('kom-campaign-video',class extends HTMLElement{connectedCallback(){if(this.ready)return;const video=this.querySelector('video');if(!video)return;this.ready=true;const controls=this.querySelector('.kom-campaign__controls'),sound=this.querySelector('[data-sound]'),play=this.querySelector('[data-playback]');video.muted=true;video.controls=false;controls.hidden=false;const sync=()=>{sound.textContent=video.muted?this.dataset.soundOn:this.dataset.soundOff;sound.setAttribute('aria-pressed',String(!video.muted));play.textContent=video.paused?this.dataset.play:this.dataset.pause;};sound.addEventListener('click',()=>{video.muted=!video.muted;sync();});play.addEventListener('click',()=>{if(video.paused)video.play().catch(sync);else video.pause();});video.addEventListener('volumechange',sync);video.addEventListener('play',sync);video.addEventListener('pause',sync);if(matchMedia('(prefers-reduced-motion: reduce)').matches)video.pause();else video.play().catch(sync);sync();}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kom-home-look"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('kom-look-carousel'))customElements.define('kom-look-carousel',class extends HTMLElement{
connectedCallback(){
this.slides=[...this.querySelectorAll('[data-look]')];if(this.slides.length<2)return;
this.abort=new AbortController();const opts={signal:this.abort.signal};this.index=0;this.elapsed=0;this.duration=Number(this.dataset.duration)||8000;this.paused=matchMedia('(prefers-reduced-motion: reduce)').matches;
this.bar=this.querySelector('.kom-look-track span');this.toggle=this.querySelector('[data-toggle]');this.querySelector('.kom-look-controls').hidden=false;
this.querySelector('[data-prev]').addEventListener('click',()=>this.show(this.index-1),opts);this.querySelector('[data-next]').addEventListener('click',()=>this.show(this.index+1),opts);
this.querySelectorAll('.kom-look__reveal').forEach(button=>button.addEventListener('click',()=>{const open=button.getAttribute('aria-expanded')!=='true';button.setAttribute('aria-expanded',String(open));button.firstElementChild.textContent=open?'Ocultar prendas':'Ver prendas del look';button.lastElementChild.textContent=open?'−':'＋';this.paused=true;this.updateToggle()},opts));
this.toggle.addEventListener('click',()=>{this.paused=!this.paused;this.updateToggle()},opts);
this.addEventListener('pointerenter',e=>{if(e.pointerType==='mouse')this.hovered=true},opts);this.addEventListener('pointerleave',()=>this.hovered=false,opts);
this.addEventListener('pointerdown',e=>{if(e.pointerType==='touch'&&e.target.closest('.kom-look__products')){this.paused=true;this.updateToggle()}},opts);
this.addEventListener('focusin',()=>this.focused=true,opts);this.addEventListener('focusout',e=>this.focused=this.contains(e.relatedTarget),opts);
this.addEventListener('shopify:block:select',e=>{const i=this.slides.findIndex(s=>s.contains(e.target));if(i>=0){this.paused=true;this.show(i);this.updateToggle()}},opts);
this.observer=new IntersectionObserver(e=>this.visible=e[0].isIntersecting,{threshold:0.3});this.observer.observe(this);this.updateToggle();let last=performance.now();
this.timer=setInterval(()=>{const now=performance.now(),delta=Math.min(now-last,250);last=now;if(!this.visible||this.paused||this.hovered||this.focused||document.hidden)return;this.elapsed+=delta;if(this.elapsed>=this.duration)this.show(this.index+1);this.bar.style.transform='scaleX('+this.elapsed/this.duration+')'},100);
}
updateToggle(){this.toggle.textContent=this.paused?'▶':'Ⅱ';this.toggle.setAttribute('aria-label',this.paused?this.toggle.dataset.play:this.toggle.dataset.pause)}
show(i){this.index=(i+this.slides.length)%this.slides.length;this.slides.forEach((s,n)=>s.hidden=n!==this.index);this.elapsed=0;this.bar.style.transform='scaleX(0)';this.querySelector('[data-count]').textContent=(this.index+1)+' / '+this.slides.length}
disconnectedCallback(){clearInterval(this.timer);this.observer?.disconnect();this.abort?.abort()}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kom-home-reels"] && !Shopify.designMode) return;
  try {
    
function loadKomReelPosters(root = document) {
  const posters = root.querySelectorAll('template[data-kom-reel-poster]');
  const load = template => template.replaceWith(template.content);
  if (!('IntersectionObserver' in window)) { posters.forEach(load); return; }
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      const template = entry.target.querySelector('template[data-kom-reel-poster]');
      if (template) load(template);
      observer.unobserve(entry.target);
    });
  }, {rootMargin: '200px'});
  posters.forEach(template => observer.observe(template.parentElement));
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => loadKomReelPosters(), {once: true});
else loadKomReelPosters();
document.addEventListener('shopify:section:load', event => loadKomReelPosters(event.target));

const komReelOpened=new Map();
function komReelTrack(name,root,id,extra={}){
  if(window.Shopify?.designMode)return;
  const data={reel_id:id,product_id:root.dataset.productId||null,placement:root.classList.contains('kom-reels--product')?'product':'home',...extra};
  try{Promise.resolve(window.Shopify?.analytics?.publish('kom:'+name,data)).catch(()=>{});}catch{}
}
function komReelPurchaseTarget(root){
  const main=document.querySelector('product-form form[id^="product-form-main-"]');
  return {form:main,picker:document.querySelector('variant-picker[context="main_product"]')};
}
function positionKomProductReels(){
  document.querySelectorAll('.kom-reels--product').forEach(root=>{
    const {form}=komReelPurchaseTarget(root);
    const buy=form?.closest('.product-info__block-item')||form?.closest('product-form');
    if(!buy)return;
    const wrapper=root.closest('.shopify-section');
    if(!wrapper||wrapper.contains(buy))return;
    root.classList.add('kom-reels--inline');
    if(buy.nextElementSibling!==wrapper)buy.after(wrapper);
  });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',positionKomProductReels,{once:true});else positionKomProductReels();
document.addEventListener('shopify:section:load',positionKomProductReels);
document.addEventListener('variant:change',positionKomProductReels);
document.addEventListener('variant:add',event=>{
  for(const item of event.detail?.items||[]){
    const seen=komReelOpened.get(String(item.product_id));
    if(seen)komReelTrack('reel_add_to_cart',seen.root,seen.id,{variant_id:String(item.variant_id||item.id),quantity:item.quantity});
  }
});
document.addEventListener('click',event=>{
  const scroll=event.target.closest('[data-reel-scroll]');
  if(scroll){const rail=scroll.closest('.kom-reels').querySelector('.kom-reels__rail');rail.scrollBy({left:rail.clientWidth*Number(scroll.dataset.reelScroll),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});}
  const trigger=event.target.closest('[data-reel-open]');
  if(trigger){
    if(event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
    const id=trigger.dataset.reelId;
    if(!/^[A-Za-z0-9_-]{5,30}$/.test(id))return;
    const root=trigger.closest('.kom-reels'),dialog=root.querySelector('dialog');
    if(!dialog?.showModal)return;
    event.preventDefault();
    const frame=document.createElement('iframe');frame.src='https://www.instagram.com/p/'+encodeURIComponent(id)+'/embed/';frame.title=trigger.getAttribute('aria-label');frame.allow='encrypted-media; fullscreen';frame.setAttribute('allowfullscreen','');
    dialog.querySelector('.kom-reels__embed').replaceChildren(frame);
    const links=dialog.querySelector('.kom-reels__dialog-links');
    if(root.classList.contains('kom-reels--product')){
      const back=document.createElement('button');back.type='button';back.dataset.reelChoose='';back.textContent=root.dataset.returnLabel;links.replaceChildren(back);
    }else{links.replaceChildren(trigger.closest('article').querySelector('.kom-reels__links').cloneNode(true));}
    dialog.querySelector('.kom-reels__instagram').href=trigger.dataset.reelUrl||trigger.href;
    dialog.addEventListener('close',()=>{dialog.querySelector('.kom-reels__embed').replaceChildren();if(dialog.dataset.choose!=='true')trigger.focus();delete dialog.dataset.choose;},{once:true});
    dialog.querySelector('.kom-reels__dialog-top span').textContent=trigger.closest('article').dataset.reelTitle;
    dialog.showModal();
    komReelTrack('reel_open',root,id);
    if(root.dataset.productId)komReelOpened.set(root.dataset.productId,{root,id});
  }
  const choose=event.target.closest('[data-reel-choose]');
  if(choose){
    const root=choose.closest('.kom-reels'),dialog=choose.closest('dialog');
    dialog.dataset.choose='true';dialog.close();
    const {form,picker}=komReelPurchaseTarget(root);
    const target=picker||form;
    if(target){target.scrollIntoView({block:'center',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});const focus=target.querySelector('input:not([type="hidden"]):not(:disabled),select:not(:disabled),button:not(:disabled)');focus?.focus({preventScroll:true});}
    komReelTrack('reel_choose_options',root,komReelOpened.get(root.dataset.productId)?.id);
  }
  const close=event.target.closest('[data-reel-close]');if(close)close.closest('dialog').close();
  if(event.target.matches('.kom-reels__dialog')){const box=event.target.getBoundingClientRect();if(event.clientX<box.left||event.clientX>box.right||event.clientY<box.top||event.clientY>box.bottom)event.target.close();}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kom-home-selection"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('kom-home-selection')){customElements.define('kom-home-selection',class extends HTMLElement{
 connectedCallback(){if(this.bound)return;this.bound=true;this.tabs=Array.from(this.querySelectorAll('[role="tab"]'));this.addEventListener('click',event=>{const tab=event.target.closest('[role="tab"]');if(tab)this.activate(tab);const arrow=event.target.closest('[data-direction]');if(arrow){const list=arrow.closest('[role="tabpanel"]').querySelector('.kom-selection__products');list.scrollBy({left:Number(arrow.dataset.direction)*list.clientWidth*.85,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});}});this.addEventListener('keydown',event=>{const tab=event.target.closest('[role="tab"]');if(!tab)return;let index=this.tabs.indexOf(tab);if(event.key==='ArrowRight')index=(index+1)%this.tabs.length;else if(event.key==='ArrowLeft')index=(index-1+this.tabs.length)%this.tabs.length;else if(event.key==='Home')index=0;else if(event.key==='End')index=this.tabs.length-1;else return;event.preventDefault();this.activate(this.tabs[index]);this.tabs[index].focus();});this.addEventListener('shopify:block:select',event=>{const panel=event.target.closest('[role="tabpanel"]');if(panel)this.activate(this.tabs.find(tab=>tab.getAttribute('aria-controls')===panel.id));});}
 activate(selected){if(!selected||selected.getAttribute("aria-selected")==="true")return;const previous=this.querySelector("[role=tabpanel]:not([hidden])");const previousHeight=previous?.getBoundingClientRect().height||0;this.tabs.forEach(tab=>{const active=tab===selected;tab.setAttribute('aria-selected',String(active));tab.tabIndex=active?0:-1;this.querySelector('#'+tab.getAttribute('aria-controls')).hidden=!active;});this.dispatchEvent(new CustomEvent('kom:tab-change',{bubbles:true,detail:{panel:this.querySelector('#'+selected.getAttribute('aria-controls')),previousHeight}}));}
});}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
if (!customElements.get('kom-product-description')) {
  customElements.define('kom-product-description', class extends HTMLElement {
    connectedCallback() {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.foldCare(), { once: true });
      } else {
        this.foldCare();
      }
    }

    foldCare() {
      const clean = text => text.replace(/\s+/g, ' ').trim();
      const isCare = text => /^(?:(?:gu[ií]a|instrucciones|recomendaciones) de |(?:preservaci[oó]n|protecci[oó]n) y )?cuidados?(?: del producto| de la prenda)?\s*:?[\s]*$/i.test(clean(text));
      const isHeading = element => {
        if (/^H[1-6]$/.test(element.tagName)) return true;
        const bold = element.querySelector('strong, b');
        return bold && clean(bold.textContent) === clean(element.textContent);
      };
      for (const block of Array.from(this.querySelectorAll('p, h1, h2, h3, h4, h5, h6'))) {
        if (block.closest('details, li, table')) continue;
        const marker = isCare(block.textContent) ? block : Array.from(block.querySelectorAll('strong, b')).find(element => isCare(element.textContent));
        if (!marker || !clean(block.textContent).startsWith(clean(marker.textContent))) continue;
        const content = document.createElement('div');
        content.className = 'kom-care__content prose';
        const inline = marker !== block && clean(marker.textContent) !== clean(block.textContent);
        if (inline) {
          const remaining = block.cloneNode(true);
          const copiedMarker = Array.from(remaining.querySelectorAll('strong, b')).find(element => isCare(element.textContent));
          copiedMarker.remove();
          content.append(remaining);
        }
        let sibling = block.nextElementSibling;
        let hasInstructions = inline;
        while (sibling) {
          const text = clean(sibling.textContent);
          const next = sibling.nextElementSibling;
          const isList = /^(UL|OL)$/.test(sibling.tagName);
          const isBullet = /^[-–—•]/.test(text);
          const isIntro = !hasInstructions && sibling.tagName === 'P' && next && /^(UL|OL)$/.test(next.tagName);
          if (sibling.querySelector('img, iframe, video, table') || sibling.tagName === 'HR' || isHeading(sibling)) break;
          const isInstruction = sibling.tagName === 'P' && /^(lavar|no usar|evitar|importante:)/i.test(text);
          if (text && !isList && !isBullet && !isIntro && !isInstruction) break;
          content.append(sibling);
          if (isList || isBullet) hasInstructions = true;
          sibling = next;
        }
        if (!clean(content.textContent)) continue;
        const details = document.createElement('details');
        details.className = 'kom-care';
        const summary = document.createElement('summary');
        summary.textContent = clean(marker.textContent).replace(/\s*:$/, '');
        details.append(summary, content);
        block.replaceWith(details);
      }
      this.refineDescription();
    }

    refineDescription() {
      if (this.dataset.refined) return;
      this.dataset.refined = 'true';
      const editorial = this.querySelector('template[data-kom-editorial]');
      if (editorial) {
        const care = Array.from(this.querySelectorAll('.kom-care'));
        const content = editorial.content.cloneNode(true);
        const preserve = editorial.hasAttribute('data-preserve-description');
        const detailsLabel = editorial.dataset.detailsLabel;
        editorial.remove();
        if (preserve) {
          const rich = content.querySelector('[data-editorial-features] .metafield-rich_text_field');
          if (rich) {
            const grid = document.createElement('div');
            grid.className = 'kom-editorial__features';
            let feature;
            for (const node of Array.from(rich.children)) {
              if (/^H[1-6]$/.test(node.tagName) || !feature) {
                feature = document.createElement('div');
                feature.className = 'kom-editorial__feature';
                grid.append(feature);
              }
              feature.append(node);
            }
            rich.parentElement.replaceWith(grid);
          }
          care.forEach(node => node.remove());
          const details = document.createElement('details');
          details.className = 'kom-care kom-editorial-original';
          const summary = document.createElement('summary');
          summary.textContent = detailsLabel;
          const original = document.createElement('div');
          original.className = 'kom-care__content prose';
          original.append(...this.childNodes);
          details.append(summary, original);
          this.replaceChildren(content, ...care, details);
        } else {
          this.replaceChildren(content, ...care);
        }
        this.classList.add('kom-description--editorial');
        return;
      }
      const title = (this.dataset.productTitle || '').trim().toLocaleLowerCase();
      const first = this.firstElementChild;
      if (first && !first.querySelector('img,video,iframe') && first.textContent.trim().toLocaleLowerCase() === title) first.remove();
      for (const parent of [this, ...this.querySelectorAll('.kom-care__content')]) {
        let list;
        for (const paragraph of Array.from(parent.children)) {
          if (paragraph.tagName === 'P' && /^\s*[-–—•]\s*/.test(paragraph.textContent) && !paragraph.querySelector('img,iframe,video')) {
            if (!list) {
              list = document.createElement('ul');
              list.className = 'kom-description-list';
              paragraph.before(list);
            }
            const item = document.createElement('li');
            item.innerHTML = paragraph.innerHTML.replace(/^(\s*(?:<[^>]+>\s*)*)[-–—•]\s*/, '$1');
            list.append(item);
            paragraph.remove();
          } else if (paragraph.textContent.trim()) {
            list = null;
          }
        }
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
